import React, { memo } from 'react';
import { Button } from 'react-bootstrap';

const getStatusBadge = (status) => {
    switch (status?.toLowerCase()) {
        case 'completed': return 'aii-badge-success';
        case 'failed': return 'aii-badge-fail';
        case 'in_progress': return 'aii-badge-info';
        case 'started': return 'aii-badge-neutral';
        default: return 'aii-badge-neutral';
    }
};

const AuditRow = memo(({ item, onClick }) => {
    return (
        <tr onClick={() => onClick(item._id)} style={{ cursor: 'pointer' }}>
            <td>
                <div>
                    {new Date(item.createdDate).toLocaleDateString("en-US", {
                        month: "short",
                        day: "numeric",
                        year: "numeric"
                    })}
                </div>
                <div>
                    {new Date(item.createdDate).toLocaleTimeString("en-US", {
                        hour: "numeric",
                        minute: "2-digit",
                        hour12: true
                    })}
                </div>
            </td>
            <td>
                {item.userDetails ? (
                    <div>
                        <span className="aii-row-user-name">{item.userDetails?._id}</span>
                        {/* <span className="aii-row-user-meta">{item.userDetails?.mobile}</span> */}
                    </div>
                ) : <span style={{ opacity: 0.5 }}>Guest</span>}
            </td>
            <td>
                <div className="aii-prompt-box">
                    {item.prompt}
                </div>
            </td>
            <td>
                <span className={`aii-badge ${getStatusBadge(item.progress)}`}>
                    {item.progress}
                </span>
                {item.anyIssue && <span style={{ marginLeft: '8px', color: '#dc2626' }}>⚠</span>}
            </td>
            <td>
                <button className="aii-btn-sm" onClick={(e) => {
                    e.stopPropagation();
                    onClick(item._id);
                }}>
                    Details
                </button>
            </td>
        </tr>
    );
});

export default AuditRow;
